import { useMemo } from "react";
import { classNames } from "@ct-react/core";
import { useTools } from "../../hooks/tools";
import { SearchBar } from "../../bundles/client-ui";
import "./search-bar-wrapper.scss";

const SearchBarIntoLayout = () => {

  const { routingData } = useTools();

  const config = useMemo(() => {
    const data = routingData("search");
    return {
      displayable: !("displayable" in data) || !!data.displayable,
      ...(!!data.targeted && !!data.withSearchParams) && { target: data.withSearchParams },
      mode: data.mode
    };
  }, [ routingData ]);

  if (!config.displayable)
    return null;

  const wrapperClasses = classNames("search-bar-wrapper", config.mode);

  return (
    <div className={wrapperClasses}>
      <SearchBar target={config.target} />
    </div>);

}

export default SearchBarIntoLayout;
